import React, { useMemo } from 'react';
import { useShipmentLedgers } from 'utils/hooks/useShipmentLedgers';
import JobList from 'components/modules/accounting/JobList';
function buildPaidLineItems(payout) {
    return payout.lineItemGroups.map((job) => ({
        _id: job.shipment_id,
        payables: job.lineItems.map((lineItem) => (Object.assign(Object.assign({}, lineItem), { payout_id: payout._id }))),
    }));
}
function populateJobPayablesWithLineItemsFromPayout(jobs, lineItemGroups) {
    return jobs.map((job) => {
        var _a;
        const payoutLineItemsForJob = lineItemGroups.find((payoutJob) => payoutJob.shipment_id === job._id);
        return Object.assign(Object.assign({}, job), { payables: (_a = payoutLineItemsForJob === null || payoutLineItemsForJob === void 0 ? void 0 : payoutLineItemsForJob.lineItems) !== null && _a !== void 0 ? _a : [] });
    });
}
export default function PayoutJobList({ payout }) {
    var _a, _b;
    const isPaid = payout.status === 'paid';
    const { data: ledgerItems, isLoading, isError, } = useShipmentLedgers((_a = payout.jobs) !== null && _a !== void 0 ? _a : [], 'payout', {
        enabled: !isPaid && ((_b = payout.jobs) !== null && _b !== void 0 ? _b : []).length > 0,
    });
    const lineItems = useMemo(() => {
        if (isPaid)
            return buildPaidLineItems(payout);
        if (!ledgerItems)
            return undefined;
        return populateJobPayablesWithLineItemsFromPayout(ledgerItems, payout.lineItemGroups);
    }, [isPaid, ledgerItems, payout]);
    return (React.createElement(JobList, { context: "payout", ledgerType: payout.type, ledgerId: payout._id, jobs: payout.lineItemGroups, lineItems: lineItems, isLoading: !isPaid && isLoading, isError: isError }));
}
